import styled from 'styled-components';
import { space, layout, background, border, flexbox, color, grid } from 'styled-system';

const Box = styled.div`
  ${space}
  ${layout}
  ${background}
  ${border}
  ${flexbox}
  ${color}
  ${grid}
`;

export default Box;
